<template>
  <div class="home-banner">
    <div class="box">
      <van-swipe class="my-swipe" :touchable="true" :autoplay="3000" indicator-color="white">
        <div  v-for="item in list" :key="item.id">
          <van-swipe-item>
            <div class="swipe-img-box">
              <van-image
                  width="100%"
                  height="100%"
                  fit="cover"
                  :src="item.image"
              />
            </div>
          </van-swipe-item>
        </div>
      </van-swipe>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeBnnaer",
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      this.$http.get(this.$api.banner.list).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.list = data
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .my-swipe {
    height: 290px;
  }
  .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
  }
}
.swipe-img-box {
  width: 100%;
  height: 290px;
}
.home-banner {
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .box {
    width: 700px;
    height: 290px;
    border-radius: 25px;
    overflow: hidden;
  }
}
</style>
